import { getFileDownloadUrl } from 'src/utils/helpers/fileUrl';
import { formatDateShort } from 'src/utils/helpers/transformDate';

export const companySideAreaDocuments = (company) => {
	const activeDocuments = [
		...(company.documents ?? []),
		...(company.contracts ?? []),
	].filter((doc) => !doc.isDeleted);

	const documents = activeDocuments
		.map((doc) => {
			const downloadUrl = getFileDownloadUrl(doc.file?.id);

			return {
				id: doc.id,
				created: doc.createdAt,
				data: {
					files: [
						{
							id: 'doc-file',
							label: doc.name,
							desc: formatDateShort(doc.createdAt),
							labelDownload: downloadUrl ? 'Скачать' : undefined,
							linkDownload: downloadUrl
								? {
									href: downloadUrl,
									target: '_blank',
								}
								: undefined,
							status: doc.signed
								? { label: 'Подписан', color: 'success' }
								: null,
						},
					],
				},
			};
		})
		.sort((a, b) => new Date(b.created) - new Date(a.created));

	if (!documents.length) return null;

	return {
		id: 'docs',
		label: 'Документы',
		items: documents,
	};
};
